import { emitAddBundleToBasketEvent } from './emitter';

export default (
  primaryVariationId,
  secondaryVariationIds,
  additionalWidgetClickTracking,
  totalPrice
) => {
  const promoAttributionFeatureValue = additionalWidgetClickTracking[
    'wk.promo_AttributionFeature'
  ][0].replace('{PAGE_NAME}', 'DetailView');

  const event = {
    primaryItem: {
      variationId: primaryVariationId,
      quantity: 1
    },
    secondaryItems: secondaryVariationIds.map((variationId) => {
      return { variationId };
    }),
    itemOrigin: 'ads-bundle',
    tracking: Object.entries({
      ...additionalWidgetClickTracking,
      'wk.promo_AttributionFeature': [promoAttributionFeatureValue],
      'wk.promo_AttributionSource': [''],
      promo_BundleSum: [totalPrice]
    }).reduce((acc, [key, value]) => {
      return {
        ...acc,
        [key]: value[0]
      };
    }, {})
  };

  emitAddBundleToBasketEvent(event);
};
